export default __webpack_public_path__ + "static/media/minute1.5eb6b6f1.png";